import { Typography, Theme, styled, useMediaQuery } from '@mui/material';

export function Brand() {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  return (
    <Typography component="div" variant="h5" color="inherit" noWrap>
      {smDown ? null : (
        <span className="visible-md visible-lg">
          <span>Diversion Control Division</span>
          <SubBrand>Drug Enforcement Administration</SubBrand>
        </span>
      )}

      {mdUp ? null : (
        <span>
          <span>Diversion Control Division</span>
        </span>
      )}
    </Typography>
  );
}

const SubBrand = styled('span')(({ theme }) => ({
  display: 'block',
  lineHeight: '1.4',
  fontSize: '1.2rem',
  fontStyle: 'italic',
}));
